import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../.services/connection.service';

declare var $;
declare var Foundation;

@Component({
  selector: 'app-rotating-ad',
  templateUrl: './rotating-ad.component.html',
  styleUrls: ['./rotating-ad.component.css']
})
export class RotatingAdComponent implements OnInit {

  
  connection: ConnectionService;
  ads = [
          {title: "HouseList.com", subTitle: "Find realtors, homes, places for rent.", text: "Are you looking to buy a home then find a featured home in your area, with", imgURL: "HLlogo.png", linkURL: "https://www.houselist.com"}, 
          {title: "LawChek.com Books", subTitle: "Free Legal Forms & Letters", text: "Are you creating a will or doing estate planing then check this site out.", imgURL: "booksLogo01.png", linkURL: "https://www.howdoicreateawill.com"}, //must be fully qualified URL
          {title: "LawChek.com", subTitle: "Should I Incorporate My Business?", text: "Starting a business. Get the information on incorporation", imgURL: "lawchekbooks2.png", linkURL: "http://www.shouldiincorporatemybusiness.com"}
        ]; 
  defaultAd; //http://www.shouldiincorporatemybusiness.com/
  adContainer;
  


  reinitializeRoller = () => {
    setTimeout(() => {
      Foundation.reInit('orbit');
    }, 1000)
  }


  constructor(private connectionService: ConnectionService) { 
    this.connection = connectionService;
  }

  member: boolean;
  adComponent: HTMLElement;

  checkIfMember = () => {
    //this member checking should be in a service
    let adComponent = document.getElementById('container-rotating-ad');
    if(this.member) {
      adComponent.classList.add('invisible');
    } else {
      this.activate();
    }
  }

  shouldDisplayAdCheck = () => {
    console.log('check')
    if(!this.member && this.connection.streamList.length > 0){ 
      this.adComponent.classList.remove('invisible');
    } else {
      this.adComponent.classList.add('invisible');
    }

    //check if element has been removed or hidden from DOM
  }

  activate = () => {
    
    $('#container-rotating-ad').draggable({
      axis: 'x',
      containment: 'parent',
    });
    
  }

  ngOnInit() {
    
    //this.reinitializeRoller();
     
  }

  ngAfterViewInit() {
    $('#container-rotating-ad').draggable({
      axis: 'x',
      containment: 'parent',
    });
  }

}
